import { useEffect, useState } from "react";

function InstallButton() {

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {

    // Se já está rodando como PWA não mostra
    const isPWA =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (isPWA) return;

    const handler = (e) => {

      e.preventDefault();

      setDeferredPrompt(e);

      setShowBanner(true);

    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);

  }, []);


  const handleInstallClick = async () => {

    if (!deferredPrompt) return;

    deferredPrompt.prompt();

    const choice = await deferredPrompt.userChoice;

    if (choice.outcome === "accepted") {

      // usuário instalou
      setShowBanner(false);

      localStorage.setItem("pwaInstalled", "true");

    }

  };


  // se já instalou não mostra
  if (localStorage.getItem("pwaInstalled") === "true") return null;

  if (!showBanner) return null;


  return (

    <div style={{
      position: "fixed",
      bottom: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "90%",
      maxWidth: "420px",
      background: "linear-gradient(135deg,#1e293b,#0f172a)",
      color: "#fff",
      padding: "14px 16px",
      borderRadius: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.35)",
      zIndex: 9999
    }}>

      <div style={{display:"flex",flexDirection:"column",flex:1}}>

        <strong style={{fontSize:"14px"}}>
          📲 Instale o App
        </strong>

        <span style={{fontSize:"12px",opacity:.8}}>
          Acesse mais rápido no celular
        </span>

      </div>

      <button
        onClick={handleInstallClick}
        style={{
          background:"#2563eb",
          border:"none",
          color:"#fff",
          padding:"8px 12px",
          borderRadius:"8px",
          fontWeight:"600",
          cursor:"pointer"
        }}
      >
        Instalar
      </button>

      <button
        onClick={()=>setShowBanner(false)}
        style={{
          background:"transparent",
          border:"none",
          color:"#fff",
          fontSize:"18px",
          cursor:"pointer"
        }}
      >
        ✕
      </button>

    </div>

  );

}

export default InstallButton;